import {useSetAtom} from "jotai";
import {modalController} from "../../store";
import DragToSelect from "../common/DragToSelect";
import {
  ModalBody,
  ModalHeader
} from "./Modal";
import React, {useEffect} from "react";
import InsertToSelect from "../common/InsertToSelect";
import {
  ColTitle,
  RowSpan,
  Script
} from "../../assets/GlobalStyles";
import styled from "styled-components";

const resolveExposureTimeType = value => {
  if (!value) {
    return "";
  }

  if (typeof value === "string") {
    return value;
  }

  return (
      value.exposureTimeType ??
      value.type ??
      value.value ??
      ""
  );
};

function TimeTableComponent({
  exposureTimeType,
  readOnly
}) {
  const timeType = () => {
    switch (exposureTimeType) {
      case "DIRECT_SETTINGS":
        return "직접 설정";

      case "EQUAL_DISTRIBUTION":
        return "균등소진";

      default:
        return "빠른소진";
    }
  };

  return (
      <TimeTableModalContainer>
        <ModalHeader
            title="설정된 시간별 예산"
        />

        <ModalBody>
          <RowSpan>
            <ColTitle>
              <strong>
                예산 소진 설정 |{" "}
                {timeType()}
              </strong>
            </ColTitle>
          </RowSpan>

          <RowSpan box={true}>
            {exposureTimeType !==
            "DIRECT_SETTINGS" ? (
                <DragToSelect
                    readOnly={readOnly}
                />
            ) : (
                <InsertToSelect
                    readOnly={readOnly}
                />
            )}
          </RowSpan>
        </ModalBody>
      </TimeTableModalContainer>
  );
}

export default function TimeTable({
  exposureTimeType,
  readOnly = false,
  trigger
}) {
  const setModal =
      useSetAtom(modalController);

  const normalizedExposureTimeType =
      resolveExposureTimeType(
          exposureTimeType
      );

  useEffect(() => {
    return () => {
      setModal({
        isShow: false
      });
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOpenTimeTable = event => {
    /*
     * form 내부에서 클릭해도 submit이 발생하지 않도록 한다.
     */
    event?.preventDefault();

    if (!normalizedExposureTimeType) {
      return;
    }

    setModal({
      isShow: true,
      width: 1200,
      modalComponent: () => (
          <TimeTableComponent
              exposureTimeType={
                normalizedExposureTimeType
              }
              readOnly={readOnly}
          />
      )
    });
  };

  if (!normalizedExposureTimeType) {
    return null;
  }

  /*
   * 커스텀 클릭 영역을 전달한 경우
   * 해당 영역에서 기존 TimeTable 팝업을 연다.
   */
  if (typeof trigger === "function") {
    return trigger({
      open: handleOpenTimeTable
    });
  }

  /*
   * trigger가 없으면 기존 아이콘 버튼을 표시한다.
   */
  return (
      <DefaultTriggerButton
          type="button"
          title="시간별 예산 설정 보기"
          aria-label="시간별 예산 설정 보기"
          onClick={
            handleOpenTimeTable
          }
      >
        <Script />
      </DefaultTriggerButton>
  );
}

const TimeTableModalContainer =
    styled.div`
      width: 100%;
    `;

const DefaultTriggerButton =
    styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 1px solid #e5e5e5;
    border-radius: 5px;
    background-color: #fff;
    color: #555;
    cursor: pointer;

    &:hover {
      border-color: #f5811f;
      background-color: #fffaf6;
      color: #f5811f;
    }

    &:focus-visible {
      outline: 1px solid #f5811f;
      outline-offset: 2px;
    }
  `;